'use client';

import React from 'react';
import KpiCard from '@/components/ui/KpiCard';
import { useCountry } from '@/context/CountryContext';
import { useLanguage } from '@/context/LanguageContext';

// Map KPI label strings to their i18n keys
const kpiLabelKeys: Record<string, string> = {
  'Total Line Materials': 'kpi.totalMaterials',
  'Active Requisitions': 'kpi.activeRequisitions',
  'Pending CD Approvals': 'kpi.pendingApprovals',
  'Tracked Connections': 'kpi.trackedConnections',
};

const kpiDeltaKeys: Record<string, string> = {
  '3.2% vs last quarter': 'kpi.deltaQuarter',
  '8 fewer than last week': 'kpi.deltaFewer',
  'Urgent, action required': 'kpi.deltaUrgent',
};

export default function DashboardKpiRow() {
  const { kpis } = useCountry();
  const { t, fmtNum } = useLanguage();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      {kpis?.map((kpi) => {
        const translatedLabel = kpiLabelKeys[kpi.label] ? t(kpiLabelKeys[kpi.label]) : kpi.label;
        const translatedDelta = kpiDeltaKeys[kpi.delta] ? t(kpiDeltaKeys[kpi.delta]) : kpi.delta;
        const translatedAlertLabel = kpi.alertLabel ? t('kpi.urgentBadge') : undefined;

        // Format numeric value through fmtNum
        const rawNum = typeof kpi.value === 'string' ? parseFloat(kpi.value.replace(/[^0-9.]/g, '')) : kpi.value;
        const formattedValue = !isNaN(rawNum) && kpi.value !== '' ? fmtNum(rawNum) : kpi.value;

        // For "this month" delta (tracked connections)
        const thisMonthMatch = kpi.delta.match(/^(\d[\d,]*) this month$/);
        let finalDelta = translatedDelta;
        if (thisMonthMatch) {
          const num = parseInt(thisMonthMatch[1].replace(/,/g, ''), 10);
          finalDelta = `${fmtNum(num)} ${t('kpi.deltaThisMonth')}`;
        }

        return (
          <KpiCard
            key={kpi?.id}
            label={translatedLabel}
            value={formattedValue}
            delta={finalDelta}
            deltaPositive={kpi?.deltaPositive}
            iconName={kpi?.iconName}
            iconColor={kpi?.iconColor}
            alert={kpi?.alert}
            alertLabel={translatedAlertLabel}
          />
        );
      })}
    </div>
  );
}